import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import SalesFlyerLightbox from './lightbox/SalesFlyerLightbox.vue';
import SalesFlyerViewPage from './SalesFlyerViewPage.vue';
import { ref } from 'vue';
import { SalesFlyerProductSearch } from '../utilities/product-list';
import { SalesFlyerResource } from '../types';
import { useDistanceFromTop }  from '../composables/distance-from-top';
import { useIsMobileAppWebView } from '../composables/mobile-app-web-view';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerView',
  props: {
    salesFlyer: null
  },
  emits: ["search"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'search', search: SalesFlyerProductSearch)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	salesFlyer: SalesFlyerResource,
}

_useCssVars((_vm, _setup) => ({
  "18a3ab78": (_setup.firstLoadedAspectRatio),
  "4b3e7890": (_setup.distanceFromTop)
}))





const isMobileAppWebView = useIsMobileAppWebView();

/**
 * Once the first image loads, we use its aspect ratio as a placeholder for
 * images that haven't loaded yet. While it's possible that pages have different
 * aspect ratios, it's likely that they'll all be the same.
 */
const firstLoadedAspectRatio = ref<number | null>();
async function handleImageLoad(e: Event) {
	if (!(e.target instanceof HTMLImageElement)) {
		return;
	}

	if (firstLoadedAspectRatio.value == null) {
		firstLoadedAspectRatio.value = e.target.naturalWidth / e.target.naturalHeight;
	}
}

const el = ref<HTMLElement | null>(null);
const { distanceFromTop } = useDistanceFromTop(el);

const showLightbox = ref<number | null>(null);
function handleEnlargePage(index: number) {
	showLightbox.value = index;
}

function handleShopPage(pageNumber: number) {
	emit('search', {
		promoNumber: props.salesFlyer.promoNumber,
		pageNumber,
	});
}


return { __sfc: true,props, emit, isMobileAppWebView, firstLoadedAspectRatio, handleImageLoad, el, distanceFromTop, showLightbox, handleEnlargePage, handleShopPage, SalesFlyerLightbox, SalesFlyerViewPage }
}

})